module.exports = __webpack_public_path__ + "ondemand/static/e3056e037/media/FifaWorldCup2026-Page.png";